import React from 'react';
import { QuestRoute } from '../../../api/QuestRoutes';
import { formatPhone, generateId, statusColors } from '../../../utility/functions';
import Dot from '../../../Dot';
import Table from '../../../table/Table';
import LinkTo from '../../../forms/LinkTo';
import GetState from '../../../GetState';
import Row from '../../../layout/Row';

const ExpiringCard = ({ ...props }) => {

    const [data] = GetState(QuestRoute.reports.expiringCard, {
        callback: e => {
            e.expired = e.expired ? 'Yes' : 'No'
        }
    })

    const tableConfig = {
        data: data,
        headers: [
            {
                label: 'Name',
                propKey: 'accountName',
            }, {
                label: 'Expiration (Month / Year)',
                propKey: 'expirationDate',
            }, {
                label: 'Card Expired',
                propKey: 'expired',
                options: true
            }, {
                label: 'Account Status',
                propKey: 'accountStatus',
                options: true
            }, {
                label: 'Phone Number',
                propKey: 'phone',
            }, {
                label: 'Email',
                propKey: 'email',
            },
        ],
        quickSort: [
            {
                label: 'Expiring',
                propKey: 'expired',
                query: 'No',
                color: '#ffa500'
            }, {
                label: 'Expired Cards',
                propKey: 'expired',
                query: 'Yes',
                color: '#bf0d14'
            }, {
                label: 'Active Users',
                propKey: 'accountStatus',
                query: 'Active',
                color: '#44ce7b'
            },
        ],
        renderFormat: (e) => (
            <tr key={generateId()}>
                <td>
                    <LinkTo
                        target='_blank'
                        toAccount={e}
                    >
                        {e.accountName.trim() || '-'}
                    </LinkTo>
                </td>
                <td>{e.expirationDate}</td>
                <td>{e.expired}</td>
                <td>
                    <Row>
                        <Dot color={statusColors[e.accountStatus]} />
                        <span>
                            {e.accountStatus}
                        </span>
                    </Row>
                </td>
                <td>{formatPhone(e.phone)}</td>
                <td>{e.email || '-'}</td>
            </tr>
        )
    }

    return (
        <Table config={tableConfig} />
    );
}

export default ExpiringCard;